var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoContentsLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "u2bk1szrza"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.619608 0 0 0 0 0.627451 0 0 0 0 0.647059 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -91)",
    filter: "url(#u2bk1szrza)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.929 102.858v1.303c0 .72-.584 1.303-1.304 1.303h-3.768a2 2 0 0 1-2-2v-6.928a2 2 0 0 1 2-2h3.723c.745 0 1.349.603 1.349 1.348v1.349M32.607 97.94l2 2.167-2 2.167",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.714 100h6.43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoContentsLogout);
export default __webpack_public_path__ + "static/media/ico-contents-logout.464a04f1f1fcd4619d9e7942c02147a1.svg";
export { ForwardRef as ReactComponent };